import React from 'react'
import { Ticket } from '@core/Areas/AccountActivity/types'
import { RaceNotificationButton } from '@core/Areas/Racing/Components/RaceNotificationButton'
import { TicketLayoutType } from '../../helpers'

export const RaceAlertButton: React.FC<{
  ticket: Ticket
  ticketLayoutType: TicketLayoutType
}> = ({ ticket, ticketLayoutType }) => {
  const leg = ticket.legs[0]

  const isSingleRace =
    ticketLayoutType === 'single-single' ||
    ticketLayoutType === 'single-multiple' ||
    ticketLayoutType === 'same-race-multi'

  const canSetAlert =
    isSingleRace && leg.meetingName && leg.raceNumber && leg.fixtureDate && leg.fixtureId

  if (!canSetAlert) {
    return null
  }

  return (
    <span data-testid='ticket-footer-alert-button'>
      <RaceNotificationButton
        raceStatus='Pending'
        raceTime={new Date(leg.advertisedStartTime)}
        meetingName={leg.meetingName}
        raceNumber={leg.raceNumber}
        meetingDate={leg.fixtureDate}
        meetingId={leg.fixtureId}
      />
    </span>
  )
}
